module.exports = __webpack_public_path__ + "img/yinye.45f55465.png";